import {
  initialState,
  Actions,
  State,
  GET_FEATURED_POSTS,
  UPDATE_GET_FEATURED_POSTS,
  GET_FEATURED_POSTS_SUCCESS,
  GET_FEATURED_POSTS_ERROR,
  RESET_GET_FEATURED_POSTS,
} from "../../types/post/get-featured-posts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_FEATURED_POSTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_FEATURED_POSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_FEATURED_POSTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_GET_FEATURED_POSTS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case RESET_GET_FEATURED_POSTS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
